<template>
  <div class="footer">
    <div style="margin-bottom:10px; height: 12px;" v-if="this.$store.getters.application.applicationCode.indexOf('ipsystur')!=-1">
        <span style="color: blue; font-size: 20px;height: 10px;">{{ this.$store.getters.language['ipsys.turProtect'] }}</span>
    </div>
    <div class="copyright">
      <span>{{language['common.footer.one']}}</span>
    </div>
<!--    <div class="links">
      <a href="" target="_blank">{{language['common.footer.two']}}</a>
    </div>-->
    <div class="copyright">
      Copyright
      <a-icon type="copyright"/>
      {{language['common.copyright.year']}}<!--2022--> <span>{{language['portal.ui2.copyright']}}<!--鴻海精密工業股份有限公司--></span>
      <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/recordQuery" style="padding-left: 5px;">{{language['common.copyright.filingweb']}}<!--粤ICP备13021698号--></a>
    </div>
  </div>
</template>

<script>
  export default {
    name: "LayoutFooter",
    computed:{
      language() {
        return this.$store.getters.language
      },
    },
  }
</script>

<style lang="less" scoped>
  .footer {
    padding: 0 16px;
    margin: 48px 0 24px;
    text-align: center;

    .links {
      margin-bottom: 8px;

      a {
        color: rgba(0, 0, 0, .45);

        &:hover {
          color: rgba(0, 0, 0, .65);
        }

        &:not(:last-child) {
          margin-right: 40px;
        }
      }
    }
    .copyright {
      color: rgba(0, 0, 0, .45);
      font-size: 14px;
    }
  }
</style> 